t = require('app/scripts/views/internal/teacup-with-helpers')('org_pref_restriction')

module.exports = ->
  t.li ->
    t.text t.mustacheVar('restriction')
    t.a '.dark-hover.js-restricted-address', { href: '#', 'data-pattern': t.mustacheVar('restriction') }, ->
      t.icon 'close', { class: 'option close' }
